export const RELOAD_MENU_CARD_REQUEST = 'RELOAD_MENU_CARD_REQUEST';

export const reloadMenuCardRequest = () => ({
    type: RELOAD_MENU_CARD_REQUEST,
});
